import React, {Component} from 'react'
import '../styles/LandingPageEmployers.css'

import {
  Link,
} from 'react-router-dom'

import {
  Button,
  Card,
  Typography,
} from 'material-ui'

import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';

import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Fade from 'material-ui/transitions/Fade'

// import SubscriptionForm from './SubscriptionForm'
// import LandingPageInfoCard from './LandingPageInfoCard'

import {
  Accent,
  bgWhite,
  Primary,
  PurpleShadow,
  Title,
} from '../helper/consts'

const style = {
  ctaBtn:{
    marginRight: '21px',
    boxShadow: `0px 10px 50px -5px ${Accent}`,
    minWidth: '150px',
    minHeight: '50px',
    borderRadius: '50px',
    margin: '50px 0 100px 0',
  },
  infoSection:{
    maxWidth: '1180px',
    width: '100%',
    padding: '100px auto',
    height: 'min-content',
    backgroundColor:bgWhite,
    display: 'flex',
    // justify-content: space-around;
    // width: 100%;
    margin: '100px auto',
    // flex-wrap: wrap;
  },
  infoContainer:{
    display: 'flex',
    justifyContent: 'space-around',
    width: 'auto',
    margin: '50px 20px',
    flexDirection:'column',
    boxShadow: `0 25px 93px -10px ${PurpleShadow}, 0 -5px 33px -10px ${PurpleShadow}`,
    padding:'20px',
    borderRadius:'20px',
  },
  // infoColumn:{
  //   display: 'flex',
  //   flexDirection: 'column',
  //   maxWidth: '39%',
  //   width: '39%',
  //   minWidth: '310px',
  //   margin: '0 10px',
  // },
  infoTitle:{
    textAlign: 'right',
    margin: '10px 10px 20px',
    color: Accent,
    fontWeight:'800',
  },
  aboutTitle:{
    textAlign: 'center',
    margin: '10px 10px 20px',
    fontWeight:'400',
    color:Primary,
    fontSize:'1.3rem',
  },
  aboutText:{
    textAlign: 'center',
    margin: '10px 10px 20px',
    fontWeight:'400',
    color:Primary,
  },
  benefitTitle:{
    color:Primary,
    fontSize:'1.2rem',
  },
  benefitAbout:{
    lineHeight:'1.7rem',
    color:Primary,
  }
  // expansion:{
  //   boxShadow:'none',
  //   backgroundColor:'transparent',
  // }
}

const points = [
  {
    title:`Easy-to-use, web-based job posting and recruitment process tool`,
    message:`The recruitment process is made simpler by complementing your traditional recruiting methods with a network referral post. Everything can simply be managed with the suite of management tools, designed for speed and ease-of-use.`,
  },
  {
    title:`Applicants come with a recommendation from the networker`,
    message:`Every applicant will come with the details of how they were referred, which people referred them, and why they were referred in the first place.`,
  },
  {
    title:`Networkers are ranked on the quality of their referrals`,
    message:`Help discover your super-connectors. Every network is comprised of different nodes - some more spread out than others. We'll help you uncover your super connectors and simplify your recruitment process for all openings going forward.`,
  },
  {
    title:`Overall improved candidate quality and cultural fit`,
    message:`The best candidates are referred candidates. The people who know whether a candidate is a good fit are those that know both your business and the candidate. That's why referral candidates ensure a greater cultural fit within organiziations.`,
  },
  {
    title:`Increased offer to acceptance ratios`,
    message:`Referred job postings receive greater numbers of qualified candidate applications that are more likely to be short-listed, and lead to a greater Offer-to-Acceptance ratio.`,
  },
  {
    title:`Decreased time spent on each recruit`,
    message:`Spend less time recruiting, and more time engaging with the qualified candidates that are directly referred to you. `,
  },
  {
    title:`Referral candidates stay an average of three times longer`,
    message:`Ensure greater employee cohesiveness and cultural fit by recruiting within your employee network and, as a result, ensuring greater employee retention.`,
  },
  {
    title:`Average cost per hire is reduced by over 50%`,
    message:`Reduce your cost-per-hire by spending less time advertising and distrubint a posting, and then spending countless hours sifting through and meeting with candidates that aren't short-listed. Instead, discover the right fit faster; right within your network.`,
  },
]

export default class LandingPageEmployers extends Component{
  constructor(){
    super();

    this.state = {
      expanded:false,
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };


  render(){
    return (
      <section id="employers" style={style.infoSection} className="body">
        <Typography style={style.infoTitle} type={'display1'}>Employers</Typography>
        <Typography className='cardWidth' style={style.aboutTitle} type={'subheading'}>Tapping into the networks of a company’s own employee base has proven to be one of the most effective and economical ways to access top talent to fill open positions. <span id='titleBrandMark'>{Title}</span>’s employee referral platform offers the following benefits:</Typography>
        <Card style={style.infoContainer} className="cardWidth">
          {points.map((point,i)=>{
            return(
              <Fade key={i} in={true}>
                <ExpansionPanel className='employerBenefit' expanded={this.state.expanded === `${i}`} onChange={this.handleChange(`${i}`)}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography style={style.benefitTitle}>{point.title}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography style={style.benefitAbout}>
                      {point.message}
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Fade>
            )
          })}
        </Card>
        <Typography className='cardWidth' style={style.aboutText} type={'subheading'}>So instead of sifting through numerous applicants, most of which aren’t qualified, try <span id='titleBrandMark'>{Title}</span> and save your precious time! To learn more, contact us today or join now.</Typography>
        <Link
          to={{
            pathname: '/Join',
            state: { tab: 'signUp' }
          }}
        >
          <Button style={style.ctaBtn} raised color='accent'>Sign Up</Button>
        </Link>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageEmployers.js